<div
  class="chip"
  [ngClass]="{
    orange: status === 'not-confirmed' || status === 'not-verified',
    red: status === 'expired' || status === 'deleted',
    green: status === 'active' || status === 'confirmed' || status === 'verified',
    small
  }"
  [matTooltip]="label | translate"
>
  <ax-icon class="icon" [name]="iconName"></ax-icon>
  {{ label | translate }}
</div>
